export default {
  screens: [
    {
      type: 'intro',
      title: 'The art of the tiara',
      content:
        'Jewellery apotheosis and symbol of the Maison, emblem of power and fashion accessory, the tiara comes in the most classic to the most extravagant designs.',
      idYt: '2YX1UzJIlp0',
      videoCover: 'world/diademe/video.jpg',
      desktop: {
        cover: 'world/diademe/cover-1.jpg'
      },
      mobile: {
        cover: 'world/diademe/mobile-cover-1.jpg',
        contentStyle: { width: '90%' },
        coverStyle: {
          width: 'auto',
          height: '65%',
          bottom: '-18%',
          right: '0',
          left: 'inherit',
          position: 'absolute'
        }
      },
      isCover: true
    },
    {
      type: 'triangle',
      desktop: {
        topImg: 'world/diademe/triangleTop.jpg',
        btmImg: 'world/diademe/triangleBtm.jpg',
        cover: 'world/diademe/cover-2.jpg'
      },
      mobile: {
        topImg: 'world/diademe/triangleTop.jpg',
        btmImg: 'world/diademe/triangleBtm.jpg',
        cover: 'world/diademe/cover-2.jpg'
      },
      content:
        'Since 1780, the Maison has created more than 2,000 tiaras, headpieces and head ornaments for the monarchy and major aristocratic families. <br/><br/> The twenty tiaras and three hundred models in nickel silver displayed in the exhibition illustrate Chaumet’s creativity and virtuosity.',
      isCover: true
    },
    {
      type: 'grid',
      videoBlock: {
        cover: 'world/diademe/video-diademe.jpg',
        idYt: 'IM2d5lCTqIA'
      },
      middleImg: 'world/diademe/gridMiddle.jpg',
      rightImg: 'world/diademe/gridRight.jpg',
      title: 'The Vertiges tiara',
      content:
        'Create the tiara of the 21st century – such was the challenge Chaumet gave to the jewellery design students of Central Saint Martins.<br/><br/> Scott Armstrong designed the Vertiges tiara by looking to French garden design. A reinvention of the Chaumet landscape, encompassed in curves and straight lines.'
    }
  ],
  mobile: {
    mainContentStyle: { paddingBottom: '20px' }
  }
}



// WEBPACK FOOTER //
// ./src/locales/en/worlds/diademe.js